var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 16.2C22.7974 16.2 26.2 12.7974 26.2 8.6C26.2 4.40264 22.7974 1 18.6 1C14.4026 1 11 4.40264 11 8.6C11 12.7974 14.4026 16.2 18.6 16.2Z",
    stroke: "#FF9515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 38.9999C35.7 29.556 28.044 21.8999 18.6 21.8999C9.15605 21.8999 1.5 29.556 1.5 38.9999",
    stroke: "#FF9515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 38.9999L22.4 34.2499L18.6 21.8999L14.8 34.2499L18.6 38.9999Z",
    stroke: "#FF9515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessdev);
export default __webpack_public_path__ + "static/media/businessdev.1146c9fd5d6779cf67ad33ba7acf8c95.svg";
export { ForwardRef as ReactComponent };